import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaTiktok, FaSnapchat } from 'react-icons/fa'; // Social media icons
import { SiX } from 'react-icons/si'; 
// Helper function to map the platform to the corresponding icon
const getSocialMediaIcon = (platform) => {
  switch (platform) {
    case 'facebook':
      return <FaFacebook />;
    case 'x':
      return <SiX />;
    case 'instagram':
      return <FaInstagram />;
    case 'tiktok':
      return <FaTiktok />;
    case 'snapchat':
      return <FaSnapchat/>;
    default:
      return null;
  }
};

const SocialMediaInput = ({
  id,
  value,
  onChange,
  placeholder,
  required,
  errorMessage,
}) => {
  const platform = id.toLowerCase(); // Use id to determine the platform (facebook, twitter, etc.)

  return (
    <div className="form-group">
      <label htmlFor={id}>
      <span className="social-media-icon">{getSocialMediaIcon(platform)}</span>
      {placeholder}
      {required && <span className="required-asterisk">*</span>}
      </label>
        <input
          type="text"
          id={id}
          value={value}
          onChange={onChange}
          placeholder={`حسابك في ${placeholder}`}
          />
      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </div>
  );
};

export default SocialMediaInput;
